import React from 'react';
import { Box, Container, Card, CardContent, Typography } from '@material-ui/core';

import Page from '../Page';
import FormLogo from '../shared/FormLogo';
import ErrorsValidation from '../shared/displayErrorsValidations';
import { PrimaryLinkButton } from '../shared/Buttons/PrimaryLinkButton';
import PageContainer from 'src/containers/shared/PageContainer';
// import { routesApp } from 'src/routesService';
// import { Link } from 'react-router-dom';

const LogoHeader = (props) => {
  const {
    auth,
    logo,
    loading,
    errors,
    updateLogo,
  } = props;

  return (
    <PageContainer title="Logo" maxWidth={false}>
        <Card>
          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
            >
              <Typography
                color="textPrimary"
                variant="h2"
                className="mb-3"
              >
                Logo de Encabezado
              </Typography>
              <PrimaryLinkButton to={`${process.env.REACT_APP_JUANAMANSO_REA}preview/header`} external>
                Previsualizar Encabezado
              </PrimaryLinkButton>
            </Box>
            <ErrorsValidation errors={errors} />
            <Box mt={3}>
              <FormLogo
                authPermissions={auth.permissions}
                footer={false}
                updateLogo={updateLogo}
                loading={loading}
                logo={logo}
              />
            </Box>
          </CardContent>
        </Card>
    </PageContainer>
  );
};

export default LogoHeader;
